import {
    CommandResponse,
    RevisionedCommandResponse,
    StudyPopulation,
    toStudyPopulation,
} from '@faro/study-designer-model';
import { StudyPathParameter } from '../parameter';
import axios from 'axios';

export type StudyPopulationPathParameters = StudyPathParameter;

/**
 * Client responsible for accessing the backend entity services
 */
export const studyPopulationClient = {
    list: (request?: StudyPopulationPathParameters, signal?: AbortSignal): Promise<StudyPopulation[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/study-populations`, {
                params: query,
                signal,
            })
            .then(response => response.data?.map(toStudyPopulation) ?? []);
    },
    update: (request: StudyPopulation, signal?: AbortSignal): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${request.studyId}/study-populations/${request.id}`, request, {
                signal,
            })
            .then(response => response.data);
    },
};
